const InitialisePayment = function (payload) {
  const debugScript = "https://pgsandbox.xpresspayments.com:8020/xpressPay.min.js";
  const productionScript = "https://myxpresspay.com:6002/xpressPay.min.js";
  const src = payload.mode === "Debug" ? debugScript : productionScript;
  let script = document.createElement("script");
  script.src = src;
  document.head.appendChild(script);

 return new Promise(function (resolve, reject) {
  script.onload = script.onreadystatechange = function () {
     XpressPay.InitialisePayment(payload).then((response) => {
      resolve(response);
    });
  };
 })
};
const VerifyPayment = function (payload) {
  const debugScript = "https://pgsandbox.xpresspayments.com:8020/xpressPay.min.js";
  const productionScript = "https://myxpresspay.com:6002/xpressPay.min.js";
  const src = payload.mode === "Debug" ? debugScript : productionScript;
  let script = document.createElement("script");
  script.src = src;
  document.head.appendChild(script);
 
  return new Promise(function (resolve, reject) {
    script.onload = script.onreadystatechange = function () {
       XpressPay.VerifyPayment(payload).then((response) => {
        resolve(response);
      });
    };
   })
}

module.exports = {
  VerifyPayment,
  InitialisePayment
}
